<template>
  <div id="app">
    <CartView />
    <keep-alive>
      <router-view v-if="isRouterAlive" class="view">
      </router-view>
    </keep-alive>
    
    <router-view v-if="!isRouterAlive"></router-view>
    <ClientHeight/>
    <PopupAd />
  </div>
</template>

<script>
  import { mapActions, mapMutations, mapGetters } from "vuex";
  import ClientHeight from "@/components/clientHeight/index.vue";
  import PopupAd from "@/components/PopupAd/index.vue";
  import { fetchAndApplyTheme } from "@/util/theme";
  import { BIZ_LANG, BIZ_LANGUAGE_MAP } from "@/common/constant";
  import { enableDecorationBridge } from "@/util/decorationBridge";
  import { getPublicSetting } from "@/api/upms/member_center";
  export default {
    name: "App",
    data() {
      return {
        tuozhuaizuobiao: {
          width: 0,
          height: 0,
          top: 0,
          left: 0,
        },
        show_kefu: false,
        kefu_url: "",
        host_url: "",
        language: "",
        itemname: process.env.VUE_APP_ITEM_NAME,
      };
    },
    components: {
      ClientHeight,
      PopupAd,
    },
    computed: {
      ...mapGetters(["existToken", "isLogin"]),
      isRouterAlive() {
        return this.$route.meta.keepAlive;
      },
    },
    /**
     * 此代码会存在bug， beforeunload, 只应该处理存储token
     * refresh时去获取一次用户信息，更新用户相关状态，而不能是整个store
     */
    created() {
      // 装修器 iframe 预览支持：URL 含 ?lang=xx 时先切语言（hash 模式 query 在 hash 后）
      try {
        const search = window.location.search || ''
        const hashQuery = (window.location.hash.split('?')[1] || '')
        const urlLang = new URLSearchParams(search).get('lang') || new URLSearchParams(hashQuery).get('lang')
        if (urlLang) localStorage.setItem(BIZ_LANG, urlLang)
      } catch (e) { /* 静默：URL 解析失败不影响主流程 */ }

      localStorage.setItem("scroll", 0);
      const currentRouter = this.$router.currentRoute;
      if (currentRouter.query.code) {
        localStorage.setItem("agentCode", currentRouter.query.code);
      }
      let link = document.head.querySelector("link");
      link.href = this.itemname =='BizSpring'?require('@/assets/image/bizspring.png'): this.itemname == 'TikTok-Wholesale' || this.itemname =='SM-wholesale shop' ? require(`@/assets/image/${this.itemname}/logo.svg`):this.itemname !== 'TikTok' && this.itemname !== 'Laz'? require(`@/assets/image/${this.itemname}/${this.itemname}logo.svg`): require(`@/assets/image/${this.itemname}/${this.itemname}logo.png`);
      document.title = this.itemname;

      // 拉取并应用激活的装修主题（先注入默认 token，再异步覆盖；失败静默走默认）
      fetchAndApplyTheme()

      // 加载公开配置
      getPublicSetting().then(res => {
        const settings = (res && res.data && res.data.data) || null;
        if (settings) {
          if (settings.siteName) {
            document.title = settings.siteName;
            localStorage.setItem('shop_siteName', settings.siteName);
          }
          if (settings.logo) {
            localStorage.setItem('shop_logo', settings.logo);
          }
          if (settings.certtext) {
            localStorage.setItem('shop_certtext', settings.certtext);
          }

          // 全局开关：多语言。关闭后隐藏语言切换并强制中文
          const multiLanguageEnabled = !(settings.multiLanguageEnabled === false || settings.multiLanguageEnabled === 'false');
          localStorage.setItem('shop_multiLanguageEnabled', multiLanguageEnabled ? 'true' : 'false');
          // #region agent log
          fetch('http://127.0.0.1:7740/ingest/a9351a5b-1e14-43d3-b4dd-3beb0ed6fb3c',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'1b1377'},body:JSON.stringify({sessionId:'1b1377',runId:'post-fix',hypothesisId:'D',location:'App.vue:settings',message:'settings resolved (no reload)',data:{multiLanguageEnabled:multiLanguageEnabled,multiCurrencyRaw:settings.multiCurrencyEnabled,bizLang:localStorage.getItem(BIZ_LANG)},timestamp:Date.now()})}).catch(()=>{});
          // #endregion
          // 语言已在挂载前（main.js）确定，这里不再 reload，避免英文闪烁

          // 全局开关：多币种。关闭后隐藏币种切换并强制使用基准币
          const multiCurrencyEnabled = !(settings.multiCurrencyEnabled === false || settings.multiCurrencyEnabled === 'false');
          localStorage.setItem('shop_multiCurrencyEnabled', multiCurrencyEnabled ? 'true' : 'false');
          // #region agent log
          fetch('http://127.0.0.1:7740/ingest/a9351a5b-1e14-43d3-b4dd-3beb0ed6fb3c',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'1b1377'},body:JSON.stringify({sessionId:'1b1377',runId:'run1',hypothesisId:'A',location:'App.vue:currencyBlock',message:'reached currency block',data:{multiCurrencyEnabled:multiCurrencyEnabled},timestamp:Date.now()})}).catch(()=>{});
          // #endregion
          if (!multiCurrencyEnabled) {
            this.$store.dispatch('loadCurrencies').then(() => {
              const base = this.$store.getters.baseCurrency;
              // #region agent log
              fetch('http://127.0.0.1:7740/ingest/a9351a5b-1e14-43d3-b4dd-3beb0ed6fb3c',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'1b1377'},body:JSON.stringify({sessionId:'1b1377',runId:'run1',hypothesisId:'B',location:'App.vue:forceBase',message:'force base after load',data:{base:base,currentBefore:this.$store.getters.currentCurrencyCode},timestamp:Date.now()})}).catch(()=>{});
              // #endregion
              if (base && this.$store.getters.currentCurrencyCode !== base) {
                this.$store.commit('SETCURRENCY', base);
              }
            }).catch(() => {});
          }

          // 通知已挂载的组件（页头/页尾等）刷新站点配置，避免组件先于异步请求挂载导致读取空值
          try {
            window.dispatchEvent(new CustomEvent('shop-settings-loaded', { detail: settings }));
          } catch (e) { /* 静默 */ }
        }
      }).catch(() => {});
      if(this.itemname == 'TikTok' || this.itemname == 'TikTok-Wholesale'){
        document.documentElement.style.setProperty(`--color-main`, '#000');
        document.documentElement.style.setProperty(`--color-submain`, '#000');
        document.documentElement.style.setProperty(`--hover-color`, '#404040');
        document.documentElement.style.setProperty(`--background`, '#fff');
        document.documentElement.style.setProperty(`--bg-border-color`, '#404040');
        document.documentElement.style.setProperty(`--active-button`, '#404040');
        document.documentElement.style.setProperty(`--color-footer`, '#EB174F');
      }
      if(this.itemname == 'Hive' || this.itemname == 'Green Mall'){
        document.documentElement.style.setProperty(`--color-main`, '#56B069');
        document.documentElement.style.setProperty(`--color-submain`, '#56B069');
        document.documentElement.style.setProperty(`--hover-color`, '#255D83');
        document.documentElement.style.setProperty(`--background`, '#fff');
        document.documentElement.style.setProperty(`--active-button`, '#56B069');
        document.documentElement.style.setProperty(`--bg-border-color`, '#56B069');
        document.documentElement.style.setProperty(`--color-footer`, '#56B069');
      }
      if(this.itemname == 'Laz'){
        document.documentElement.style.setProperty(`--color-main`, '#110288');
        document.documentElement.style.setProperty(`--color-submain`, '#0A0057');
        document.documentElement.style.setProperty(`--hover-color`, '#FC019D');
        document.documentElement.style.setProperty(`--background`, '#fff');
        document.documentElement.style.setProperty(`--bg-border-color`, '#FC019D');
        document.documentElement.style.setProperty(`--active-button`, '#FC019D');
        document.documentElement.style.setProperty(`--color-footer`, '#FC019D');
      }
      if(this.itemname == 'INT Overstock'){
        document.documentElement.style.setProperty(`--color-main`, '#1A4E8A');
        document.documentElement.style.setProperty(`--color-submain`, '#0D2D58');
        document.documentElement.style.setProperty(`--hover-color`, '#0079D2');
        document.documentElement.style.setProperty(`--background`, '#fff');
        document.documentElement.style.setProperty(`--bg-border-color`, '#1A4E8A');
        document.documentElement.style.setProperty(`--active-button`, '#0D2D58');
        document.documentElement.style.setProperty(`--color-footer`, '#0079D2');
      }
      if(this.itemname == 'AntMall'){
        document.documentElement.style.setProperty(`--color-main`, '#1C1196');
        document.documentElement.style.setProperty(`--color-submain`, '#0A0639');
        document.documentElement.style.setProperty(`--hover-color`, '#0A0639');
        document.documentElement.style.setProperty(`--background`, '#fff');
        document.documentElement.style.setProperty(`--bg-border-color`, '#0A0639');
        document.documentElement.style.setProperty(`--active-button`, '#0A0639');
        document.documentElement.style.setProperty(`--color-footer`, '#F78F22');
      }
      if(this.itemname == 'SM-wholesale shop'){
        document.documentElement.style.setProperty(`--color-main`, '#002FFF');
        document.documentElement.style.setProperty(`--color-submain`, '#0023BD');
        document.documentElement.style.setProperty(`--hover-color`, '#0023BD');
        document.documentElement.style.setProperty(`--background`, '#fff');
        document.documentElement.style.setProperty(`--bg-border-color`, '#0023BD');
        document.documentElement.style.setProperty(`--active-button`, '#0023BD');
        document.documentElement.style.setProperty(`--color-footer`, '#F78F22');
      }
      // if (sessionStorage.getItem('store')) {
      //   this.$store.replaceState(
      //       Object.assign(
      //           {},
      //           this.$store.state,
      //           JSON.parse(sessionStorage.getItem('store'))
      //       )
      //   );
      // }
      // 在页面刷新时将store保存到sessionStorage里
      // window.addEventListener('beforeunload', () => {
      //   sessionStorage.setItem('store', JSON.stringify(this.$store.state));
      // });
      
    },
    mounted() {
      // 装修器画布 iframe 桥接：仅在 ?previewPageId + 被父窗内嵌时启用，生产页面 no-op
      enableDecorationBridge();
      // if (this.existToken) {
      //   this.getUserInfo();
      // }
      if(this.isLogin){
          let biz_token= this.$store.state.token;
          let biz_userInfo=this.$store.state.userInfo;
          if(biz_token&&biz_userInfo){
            let handerData={
                      'authorization':'Bearer ' + biz_token,
                      'userId':biz_userInfo.id,
                      'username':biz_userInfo.username
                    }
            this.setHanders(handerData)
          }
          this.applyMemberLanguagePreference();
      }
      const rtlLangs = ['ar', 'ur', 'fa', 'pr'];
      const lang = localStorage.getItem('BIZ_LANG')
      if (rtlLangs.includes(lang)) {
        document.documentElement.setAttribute('dir', 'rtl');
      } else {
        document.documentElement.setAttribute('dir', 'ltr');
      }
    },
    methods: {
      ...mapActions(["applyMemberLanguagePreference"]),
      // ...mapActions(["getUserInfo"]),
      ...mapMutations({
        // updateCheckProductPay: "cart/updateCheckProductPay",
        // updateCartItems: "cart/updateCartItems",
      }),
      ...mapMutations({ setHanders:"SETHANDERS" }),
      //拖拽事件
      resize(newRect) {
        this.tuozhuaizuobiao.width = newRect.width;
        this.tuozhuaizuobiao.height = newRect.height;
        this.tuozhuaizuobiao.top = newRect.top;
        this.tuozhuaizuobiao.left = newRect.left;
      },
      activateEv() {
        // 结局文本框无法输入的问题
        if (this.$refs["chat"] && this.$refs["chat"].$refs["input"]) {
          this.$refs["chat"].$refs["input"].focus();
        }
      },
    },
  };
</script>

<style>
  #app {
    min-height: 100vh;
    overflow-x: hidden;
  }
  html,body{
    scroll-behavior: smooth;
    overflow-x: hidden;
    overflow-y: auto;
  }
  body {
    margin: 0;
    overflow-y: auto;
    overflow-x: hidden;
  }

  /* 客服 */
  .service-box {
    position: fixed;
    right: 15px;
    bottom: 1px;
    cursor: pointer;
    z-index: 9999;
  }

  .vdr.active:before {
    display: none;
  }
</style>
<style scoped lang="scss">
  .kefu {
    position: fixed;
    right: 500px;
    top: 200px;
    cursor: pointer;
    z-index: 3;
  }

  .embed-responsive-item {
    width: 100%;
    height: 100%;
    border: none;
  }

  .kefu-title {
    width: 100%;
    height: 61px;
    position: relative;
    text-align: center;
    background: linear-gradient(
      90.3deg,
      rgba(45, 45, 53, 0.71) 0.21%,
      #23232e 99.83%
    );
    border-radius: 10px 10px 0px 0px;
  }

  .kegu-nrkegu-nr {
    width: 100%;
    height: 559px;
  }

  .kefu-title span {
    text-align: center;
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 61px;
    color: #ffffff;
  }

  .kefu-title img {
    position: absolute;
    width: 30px;
    height: 30px;
    right: 21px;
    top: 16px;
  }

  .kefu-tuozhuai {
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);
    outline: none;
    background: #ffffff;
    border-radius: 10px;
  }
</style>
